import { ThemeFamilies } from './types';
var getButtonSegmentElement = function (colors) {
    var _a;
    return (_a = {},
        _a[ThemeFamilies.PRIMARY] = {
            main: colors.surfaceFamilies.highlights,
            light: colors.white,
            selectedText: colors.secondaryText,
            text: colors.grey.grey50,
            dark: colors.surfaceFamilies.primaryHover,
            disabled: colors.surfaceFamilies.primaryDisabled,
            disabledText: colors.grey.grey30,
        },
        _a);
};
export default getButtonSegmentElement;
